<template>
  <div
    v-if="floorMinMax[0] !== null && floorMinMax[1] !== null"
    class="plans-filter-floor"
  >
    <div class="plans-filter-floor__label">Этаж</div>
    <CustomSlider
      v-model="floorFilter"
      :min="floorMinMax[0]"
      :max="floorMinMax[1]"
      :format="floorFilterFormat"
    />
  </div>
</template>

<script>
import CustomSlider from "@/components/CustomSlider.vue";
import _minBy from "lodash/minBy";
import _maxBy from "lodash/maxBy";

export default {
  components: {
    CustomSlider,
  },

  inject: ["filterStore"],

  props: {
    flats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      floorFilter: [null, null],
      floorMinMax: [null, null],
    };
  },

  computed: {
    floorFilterActive() {
      return this.filterStore.state.filterFloor;
    },
  },

  watch: {
    flats: {
      handler(newFlats) {
        if (newFlats && newFlats.length > 0) {
          this.setFloorMinMax(newFlats);
        }
      },
      immediate: true,
    },
    floorFilter: {
      handler(newValue) {
        if (newValue[0] !== null && newValue[1] !== null) {
          this.filterStore.setFilterFloor(newValue);
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.flats.length > 0) {
      this.setFloorMinMax(this.flats);
    }
    if (this.floorFilterActive && this.floorFilterActive[0] !== null) {
      this.floorFilter = this.floorFilterActive;
    }
  },

  methods: {
    floorFilterFormat(value) {
      return value.toFixed(0);
    },

    setFloorMinMax(flats) {
      if (flats && flats.length > 0) {
        let floorMin = _minBy(flats, "floor.number")?.floor.number;
        let floorMax = _maxBy(flats, "floor.number")?.floor.number;

        // TODO: set max floor hardcode
        if (floorMax < 15) {
          floorMax = 15;
        }

        if (typeof floorMin === "number" && typeof floorMax === "number") {
          this.floorMinMax = [floorMin, floorMax];
          if (!this.floorFilterActive || this.floorFilterActive[0] === null) {
            this.floorFilter = [floorMin, floorMax];
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.plans-filter-floor {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.plans-filter-floor__label {
  font-weight: 500;
  font-size: 14px;
  color: #291f1f;
}

@media (max-width: 768px) {
  .plans-filter-floor__label {
    font-size: 12px;
  }
}
</style>
